import { useIsWide } from 'libs/utils/logic/ui/responsiveLogic';
import { CustomActionButton } from 'pages/custom/shared/CustomHeader/CustomActionButton';
import { useContext } from 'react';
import { CtxModal } from 'session/ctxModal';
import styled from 'styled-components/macro';

interface Props {
    className?: string;
}

export const TechportButtons = (props: Props): JSX.Element => {
    const ctxModal = useContext(CtxModal);
    const isWide = useIsWide();

    function showContent() {
        ctxModal.setShowListOfStories(true);
        ctxModal.setDetailModal(null);
    }
    return (
        <S_TechportButtons className={props.className}>
            <S_Button
                iconSet="far"
                iconName="book"
                text={'Info og program'}
                onClick={() => {
                    showContent();
                }}
                inline={!isWide}
            />
        </S_TechportButtons>
    );
};

const S_TechportButtons = styled.div`
    display: flex;
    width: 100%;
    height: 100%;
    @media only screen and (min-width: 1259px) {
        width: unset;
    }
`;

const S_Button = styled(CustomActionButton)`
    width: 100%;
    @media only screen and (min-width: 1259px) {
        min-width: 150px;
        width: unset;
    }
`;
